export default "__VITE_ASSET__zv_vaFlk__"